"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMarkdown = void 0;
const md_utils_1 = require("../../../export/md.utils");
const toMarkdown = (element, context) => {
    var _a, _b, _c;
    const image = (_a = element.value) === null || _a === void 0 ? void 0 : _a.image;
    if (!image) {
        return '';
    }
    const url = (0, md_utils_1.getFileUrl)(image, context);
    if (!url) {
        return '';
    }
    const alt = ((_c = (_b = element.value) === null || _b === void 0 ? void 0 : _b.image) === null || _c === void 0 ? void 0 : _c.accessibility) || 'Image';
    return `![${alt}](${url})`;
};
exports.toMarkdown = toMarkdown;
